import React from 'react'
import { Link } from 'react-router-dom'

function Header() {
  return (
    <div>
         {/* Spinner Start */}
    {/* <div
      id="spinner"
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div> */}
    {/* Spinner End */}

    {/* Topbar Start */}
    <div className="container-fluid bg-dark px-5 d-none d-lg-block">
      <div className="row gx-0">
        <div className="col-lg-10 text-center text-lg-start mb-2 mb-lg-0">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            <small className="me-3 text-light">
              <i className="fas fa-map-marker-alt me-2" style={{fontWeight: 900}} />
              20, Green height campus, Gulmohar colony, Bhopal
            </small>
            <small className="me-3 text-light">
              <i className="fas fa-phone-alt me-2" style={{fontWeight: 900}} />
              +91 7828947721
            </small>
            <small className="me-3 text-light">
              <i className="fas fa-phone-alt me-2" style={{fontWeight: 900}} />
              +91 8770273787
            </small>
            <small className="text-light">
              <i className="fas fa-envelope me-2" style={{fontWeight: 900}} />
              theholidayroyal@gmail.com
            </small>
          </div>
        </div>
        <div className="col-lg-2 text-end">
          <div
            className="d-inline-flex align-items-center"
            style={{ height: 45 }}
          >
            <a
              className="text-light small text-decoration-none"
              href="https://www.instagram.com/holidayroyalindia"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram me-2" />
              Instagram
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* Topbar End */}
    {/* Navbar & Hero Start */}
    <div className="container-fluid position-relative p-0">
      <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
        <Link to="/" className="navbar-brand p-0">
          <img src="/assets/img/logo.png" alt="Logo" style={{ height: '100px' }} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars" />
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav ms-auto py-0">
            <Link to="/" className="nav-item nav-link">
              Home
            </Link>
            <Link to="/About" className="nav-item nav-link">
              About
            </Link>
            <Link to="/Services" className="nav-item nav-link">
              Services
            </Link>
            <Link to="/Packages" className="nav-item nav-link">
              Packages
            </Link>
            {/* <div className="nav-item dropdown">
              <Link
                to="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Pages
              </Link>
              <div className="dropdown-menu m-0">
                <Link to="/Destination" className="dropdown-item">
                  Destination
                </Link>
                <Link to="/Booking" className="dropdown-item">
                  Booking
                </Link>
                <Link to="/Team" className="dropdown-item">
                  Travel Guides
                </Link>
                <Link to="/Testimonial" className="dropdown-item">
                  Testimonial
                </Link>
                <Link to="/Error" className="dropdown-item">
                  404 Page
                </Link>
              </div>
            </div> */}
            <Link to="/Contact" className="nav-item nav-link">
              Contact
            </Link>
            <a
              href="https://www.instagram.com/holidayroyalindia"
              className="nav-item nav-link d-lg-none"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram me-2" />
              Instagram
            </a>
          </div>
       
        </div>
      </nav>
    </div>
    {/* Navbar & Hero End */}
    </div>
  )
}

export default Header
